module.exports = __webpack_public_path__ + "static/media/mediaTableDeleteIcon.64c70927.svg";